module.exports = __webpack_public_path__ + "static/media/gopalakrishnan.ada74461.png";